export default "__VITE_ASSET__BQtJWWx8__"